import * as yup from 'yup';
import {i18n2} from 'features/i18n/i18n';

export const ProfCollaborator = (management = false) => {
  const realCollaboSchema = () =>
    yup.object({
      employee_Nr: yup.number().label(i18n2._('Numero de empleado')),
      cwid: yup.string().label(i18n2._('CWID')),
      name: yup.string().label(i18n2._('Nombre')),
      profileDesc: yup.number().label(i18n2._('Descripcion del SPAC')),
      name_Profile: yup.string().label('Perfil'),
      name_Sector: yup.string().label('Sector'),
      name_Shift: yup.string().label('Turno'),
    });

  const assistanceSchema = () =>
    yup.object({
      assists: yup.boolean().label(i18n2._('Inscripto')),
    });

  return management === true
    ? assistanceSchema().concat(realCollaboSchema())
    : realCollaboSchema();
};
